import { Config } from '../../../../configFields';

export const config: Config & { name: 'SYSTEM_SCREEN' } = {
  name: 'SYSTEM_SCREEN',
  title: 'По умолчанию',
};
